import { BrowserRouter as Router, Routes, Route ,Navigate} from 'react-router-dom';
import Layout from './components/layout/Layout';


// Pages
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services/index'; // Updated import path
import Projects from './pages/Projects';
import Certificates from './pages/Certificates';
import Careers from './pages/Careers';
import Contact from './pages/Contact';

// Service Pages
import BimService from './pages/Services/BimService';
import EngineeringConsultation from './pages/Services/EngineeringConsultation';
import StructuralEngineering from './pages/Services/StructuralEngineering';
import OffshoreServices from './pages/Services/OffshoreServices';
import ProcessPlant from './pages/Services/ProcessPlant';
import ManufacturingSupply from './pages/Services/ManufacturingSupply';
import Login from './pages/Login';
// import ProtectedRoute from './components/auth/ProtectedRoute';
import Dashboard from './pages/Dashboard';
import { WOW } from 'wowjs';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/certificates" element={<Certificates />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />

          {/* Service Routes */}
          <Route path="services/bim" element={<BimService />} />
          <Route path="services/engineering-consultation" element={<EngineeringConsultation />} />
          <Route path="services/structural-engineering" element={<StructuralEngineering />} />
          <Route path="services/offshore" element={<OffshoreServices />} />
          <Route path="services/process-plant" element={<ProcessPlant />} />
          <Route path="services/manufacturing-supply" element={<ManufacturingSupply />} />
        
          <Route path="/login" element={<Login />} />
          <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;